import { ContractType } from '@received/pricing-model';
import { ContractV2 } from '../ContractComponentV2/ContractV2';

export const EnterpriseContractV2 = () => {
	return <ContractV2 contractType={ContractType.ENTERPRISE} mainUrlToReturn='../customers' />;
};
